import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

function CancellationPolicy() {
  return (
    <>
    <Navbar/>
    <div className='aboutbanner'>
    <h3>Cancellation Policy</h3>
    <p>HOME - Cancellation Policy</p>

    </div>
    <div className='tnc'>
    <h1>Welcome to Alura!</h1>
    <p>These terms and conditions outline the rules and regulations for the use of Company Name's Website, located at <a href="https://www.website.com">Website.com</a>.</p>
    <p>By accessing this website we assume you accept these terms and conditions. Do not continue to use Alura if you do not agree to take all of the terms and conditions stated on this page.</p>
    
    <h2>Definitions</h2>
    <p>The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements:</p>
    <ul>
        <li>“Client”, “You” and “Your” refers to you, the person log on this website and compliant to the Company's terms and conditions.</li>
        <li>“The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company.</li>
        <li>“Party”, “Parties”, or “Us”, refers to both the Client and ourselves.</li>
    </ul>
    <p>All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client's needs in respect of provision of the Company's stated services, in accordance with and subject to, prevailing law of Netherlands.</p>
    
    <h2>Cookies</h2>
    <p>We employ the use of cookies. By accessing Alura, you agreed to use cookies in agreement with the Company Name's Privacy Policy.</p>
    
    <h2>License</h2>
    <p>Unless otherwise stated, Company Name and/or its licensors own the intellectual property rights for all material on Alura. All intellectual property rights are reserved. You may access this from Alura for your own personal use subjected to restrictions set in these terms and conditions.</p>
    <h3>You must not:</h3>
    <ul>
        <li>Republish material from Alura</li>
        <li>Sell, rent or sub-license material from Alura</li>
        <li>Reproduce, duplicate or copy material from Alura</li>
        <li>Redistribute content from Alura</li>
    </ul>
    <p>This Agreement shall begin on the date hereof.</p>
    
    <h2>Comments</h2>
    <p>Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. Company Name does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of Company Name, its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions.</p>
    <p>To the extent permitted by applicable laws, Company Name shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.</p>
    
    <p>Company Name reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.</p>
    
    <h3>You warrant and represent that:</h3>
    <ul>
        <li>You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;</li>
        <li>The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;</li>
        <li>The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy;</li>
        <li>The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.</li>
    </ul>
    <p>You hereby grant Company Name a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.</p>


    </div>

    <Footer/>
   </>
  )
}

export default CancellationPolicy